exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#whatsapp[data-v-6e5ccf00]{position:fixed;display:flex;justify-content:center;align-items:center;bottom:6%;width:50px;height:50px;right:5%;background-color:#25d366;color:#fff;padding:8px;border-radius:50%;z-index:999;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e5ccf00","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/WhatsappHotel.vue
// module id = 558
// module chunks = 2